var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLyLibya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_20459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 0H-15V45H75V0Z",
    fill: "#239E46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 0H-15V33.75H75V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 0H-15V11.25H75V0Z",
    fill: "#E70013"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0221 18.522C26.7528 18.0005 27.6131 17.6904 28.5085 17.6257C29.4039 17.561 30.2998 17.7442 31.098 18.1551C31.8961 18.5661 32.5656 19.189 33.0331 19.9554C33.5005 20.7219 33.7478 21.6023 33.7478 22.5C33.7478 23.3977 33.5005 24.2781 33.0331 25.0446C32.5656 25.811 31.8961 26.4339 31.098 26.8449C30.2998 27.2558 29.4039 27.439 28.5085 27.3743C27.6131 27.3096 26.7528 26.9995 26.0221 26.478C26.8088 27.2645 27.8111 27.8001 28.9022 28.017C29.9933 28.234 31.1242 28.1225 32.152 27.6967C33.1797 27.2709 34.0581 26.5499 34.6761 25.6249C35.2942 24.6999 35.624 23.6125 35.624 22.5C35.624 21.3875 35.2942 20.3001 34.6761 19.3751C34.0581 18.4501 33.1797 17.7291 32.152 17.3033C31.1242 16.8775 29.9933 16.7661 28.9022 16.983C27.8111 17.1999 26.8088 17.7355 26.0221 18.522ZM27.2641 22.5L19.6951 20.043L24.3751 26.478V18.522L19.6951 24.957L27.2641 22.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_20459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyLibya);
export default __webpack_public_path__ + "static/media/ly Libya.ed32bb7df9ad788384808153bcf78d26.svg";
export { ForwardRef as ReactComponent };